import {
  LifeCycleDoc,
  FilterRequest,
  LifeCycleResponse,
  LifeCyclesResponse,
  LifeCycleLightResponse,
} from '@/types/entities';
import { ApiService } from './api.service';
import { endpoints } from './endpoints';

/**
 * Service for handling life cycle-related API calls
 */
export class LifeCyclesApiService extends ApiService {
  // Get all life cycles (reference data)
  getAll = async (): Promise<LifeCycleLightResponse> => this.get(endpoints.lifeCycles.all);

  getFilteredLifeCycles = async (filters: FilterRequest): Promise<LifeCyclesResponse> =>
    this.post(endpoints.lifeCycles.filtered, filters);

  deleteLifeCycle = async (id: string): Promise<void> =>
    this.delete(endpoints.lifeCycles.delete(id));

  getLifeCycleById = async (id: string): Promise<LifeCycleResponse> =>
    this.get(endpoints.lifeCycles.byId(id));

  createLifeCycle = async (data: Partial<LifeCycleDoc>): Promise<LifeCycleDoc> =>
    this.post(endpoints.lifeCycles.create, data);

  updateLifeCycle = async (id: string, data: Partial<LifeCycleDoc>): Promise<LifeCycleDoc> =>
    this.patch(endpoints.lifeCycles.update(id), data);
}

// Export a singleton instance
export const lifeCyclesApiService = new LifeCyclesApiService();

// Named exports for convenience
export const {
  getAll: getLifeCycles,
  getFilteredLifeCycles,
  deleteLifeCycle,
  getLifeCycleById,
  createLifeCycle,
  updateLifeCycle,
} = lifeCyclesApiService;
